import { render, staticRenderFns } from "./FactionView.vue?vue&type=template&id=329fc17c&"
import script from "./FactionView.vue?vue&type=script&lang=js&"
export * from "./FactionView.vue?vue&type=script&lang=js&"
import style0 from "./FactionView.vue?vue&type=style&index=0&id=329fc17c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports